import React from 'react';

import Setup from './Setup';
import { COPIES } from './stubs';

export function Paperless({
  value = {},
  onChange = () => {},
  isDisabled = false
}) {
  return (
    <Setup
      title={COPIES.PAPERLESS.TITLE}
      caption={COPIES.PAPERLESS.DESCRIPTION}
      value={value}
      onChange={(updates, runValidation) =>
        onChange('paperless', updates, runValidation)
      }
      isDisabled={isDisabled}
    />
  );
}

export function NoBoxNoLabel({
  value = {},
  onChange = () => {},
  isDisabled = false
}) {
  return (
    <Setup
      title={COPIES.NO_BOX_NO_LABEL.TITLE}
      caption={COPIES.NO_BOX_NO_LABEL.DESCRIPTION}
      value={value}
      onChange={(updates, runValidation) =>
        onChange('no_box_no_label', updates, runValidation)
      }
      isDisabled={isDisabled}
    />
  );
}
